///---------------------------------------------------------------------------
//! Copyright (C) ASQUARED SRL - All Rights Reserved
//* Unauthorized copying of this file, via any medium is strictly prohibited
//* Proprietary and confidential
//* Written by Alexandru Gârbacea <g99.alex@yahoo.com>, September 2022
//? @author g99.alex@yahoo.com
///---------------------------------------------------------------------------

import React, {useRef, useEffect, useState, useCallback} from 'react'
import { createPortal } from 'react-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner, faXmark } from '@fortawesome/free-solid-svg-icons'
import { FixedSizeList as List } from "react-window";

import { countryCodes, countryNames, EuCountries } from '../../databases/CountryCodes';
import { createNotification } from '../../services/NotificationService';
import { DeliveryConditions } from '../../databases/DeliveryCondition';
import { TransactionNatures } from '../../databases/TransactionNature';
import { CoduriVamale, Definitions } from '../../databases/CodVamal'
import { TransportModes } from '../../databases/TransportMode';
import { CurrencyCode } from '../../databases/Currencies';


const ListRow = ({data, index, style}) => {
    const {selectValue, items} = data
    const cod = items[0][index]
    const description = items[1][index]
    return(
        <div className='md-list-item' style={style} onClick={() => selectValue(cod)} key={`${cod} - ${index}`}>
            <span className='md-list-item__code'>{cod}</span>
            {description && <span className='md-list-item__desc'>{description}</span>}
        </div>
    )
}

const ModalSetValue = ({values, close, setValue}) => {
    const [loadSearch, setLoadSearch] = useState(false);
    const [noDescription, setNoDescription] = useState(false);
    const [queryCode, setQueryCode] = useState('');
    const [currentArray, setCurrentArray] = useState([]);
    const [textArray, settextArray] = useState([]);
    const [queryDescr, setQueryDescr] = useState('');
    const [items, setItems] = useState([])
    const [itemCount, setItemCount] = useState(0)
    const [listWidth, setListWidth] = useState(600)
    const listRef = useRef();
    const bodyRef = useRef();

    const OUTSIDE_ID = 'modal-setvalue-wrapper-bg'

    const handleOutsideClick = (id) => {
        if(id === OUTSIDE_ID) close()
    }

    // Measure available width for the virtualized list
    const measureWidth = useCallback(() => {
        if (bodyRef.current) {
            setListWidth(bodyRef.current.clientWidth)
        }
    }, [])

    useEffect(() => {
        measureWidth()
        window.addEventListener('resize', measureWidth)
        return () => window.removeEventListener('resize', measureWidth)
    }, [measureWidth])

    const setData = () => {
        const type = values.type;
        let currentArrayNow = [];
        let textArrayNow = [];

        // non-required
        // Currency          [-1]
        if ( type === -1 ) {
            currentArrayNow = new Array(...CurrencyCode);
            textArrayNow = new Array(currentArrayNow.length).fill('');
            setNoDescription(true);
        }
        // required
        // Cod Vamal          [00]
        if ( type === 0 ) {
            currentArrayNow = Array.from(CoduriVamale);
            textArrayNow = new Array(...Definitions);
        }
        // Conditie Livrare   [03]
        else if ( type === 3 ) {
            currentArrayNow = DeliveryConditions.map(val => val.code);
            textArrayNow = DeliveryConditions.map(val => val.value);
        }
        // Tara Origine       [04]
        else if ( type === 4 ) {
            currentArrayNow = new Array(...countryCodes);
            textArrayNow = new Array(...countryNames);
        }
        // Tara Expediere     [05]
        else if ( type === 5 ) {
            currentArrayNow = EuCountries.Item.map(val => val.Code);
            textArrayNow = EuCountries.Item.map(val => val.NameRo);
        }
        // Natura Tranzactiei [07]
        else if ( type === 7 ) {
            currentArrayNow = TransactionNatures.map(val => `${val.categ}.${val.code}`);
            textArrayNow = TransactionNatures.map(val => val.value);
        }
        // Mod Transport      [08]
        else if ( type === 8 ) {
            currentArrayNow = TransportModes.map(val => val.code);
            textArrayNow = TransportModes.map(val => val.value);
        }
        else {
            textArrayNow = new Array(currentArrayNow.length).fill('');
        }
        setCurrentArray(currentArrayNow)
        settextArray(textArrayNow)
        setItems([currentArrayNow, textArrayNow])
        setItemCount(currentArrayNow.length)
    }

    const filterData = () => {
        if(currentArray.length === 0) {
            return
        }
        if(queryCode === '' && queryDescr === '') {
            setItemCount(currentArray.length)
            return setItems([currentArray, textArray])
        }
        const arrCurrent = currentArray;
        const arrText = textArray;

        let finalArray = []
        let definitionsArray = queryCode !== '' ? [] : arrText

        finalArray = queryCode !== '' ? arrCurrent.filter((item, index) => {
            if(item.toString().toUpperCase().includes(queryCode.toString().toUpperCase())) {
                definitionsArray.push(arrText[index])
                return true
            }
            return false
        }) : arrCurrent

        let finalArrayHelper = queryDescr === '' ? finalArray : []

        const finalDefinitions = queryDescr !== '' ? definitionsArray.filter((item, index) => {
            if(item.toString().toUpperCase().includes(queryDescr.toString().toUpperCase())) {
                finalArrayHelper.push(finalArray[index])
                return true
            }
            else
                return false
        }) : definitionsArray

        setItems([finalArrayHelper, finalDefinitions])
        finalArrayHelper.length > 0 && setItemCount(finalArrayHelper.length)
    }

    // on start
    useEffect(() => {
        setData()
        setLoadSearch(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            setLoadSearch(true)
            filterData()
            setLoadSearch(false)
        }, 400)
        return () => clearTimeout(delayDebounceFn)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [queryCode, queryDescr])

    const selectValue = (cod) => {
        if(!cod || cod === '') return false
        if(setValue === false) {
            navigator.clipboard.writeText(cod)
            createNotification('success', `Codul ${cod} a fost copiat în clipboard`)
        }
        else
            setValue(cod, values.bigIndex, values.smallIndex, values.type);
        close();
    }

    const handleChange = (type, value) => {
        value !== '' && setLoadSearch(true)
        if (type === 0) {
            return setQueryCode(value)
        }
        else {
            return setQueryDescr(value)
        }
    }

    //? Rendered into <body> for the same reason as Popup: .handle-section keeps a
    //? transform after its animation, which would capture this position:fixed overlay
    //? and centre it on the table instead of the viewport.
    return createPortal(
        <div className='md-overlay' id={OUTSIDE_ID} onClick={(e) => handleOutsideClick(e.target.id)}>
            <div className='md-modal md-modal--lg'>
                <div className='md-header'>
                    <h2 className='md-header__title'>Valori valide</h2>
                    <button className='md-header__close' onClick={() => close()}>
                        <FontAwesomeIcon icon={faXmark} />
                    </button>
                </div>

                <div className='md-search'>
                    <span className='md-search__label'>Caută</span>
                    <div className='md-search__inputs'>
                        <input type='text'
                            placeholder='Cod' id='search-code' defaultValue={''}
                            onChange={(e) => handleChange(0, e.target.value)}
                            autoFocus
                        />
                        <input type='text'
                            placeholder='Denumire' id='search-name' defaultValue={''} disabled={noDescription}
                            onChange={(e) => handleChange(1, e.target.value)}
                        />
                    </div>
                </div>

                <div className='md-body' ref={bodyRef} style={{padding: 0}}>
                    {itemCount !== 0 && !loadSearch ?
                    <List ref={listRef}
                        height={420}
                        width={listWidth}
                        itemSize={56}
                        itemCount={itemCount}
                        itemData={{selectValue, items}}
                    >
                        {ListRow}
                    </List> :
                    <div style={{display:'flex', justifyContent:'center', padding:'3em'}}>
                        <FontAwesomeIcon className='spinner' icon={faSpinner}/>
                    </div>
                    }
                </div>
            </div>
        </div>,
        document.body
    )
}

export default ModalSetValue
